module.exports = __webpack_public_path__ + "img/logo-PRTG.88ed7ea4.svg";